<div *ngIf="rounds?.length! > 0; else noRounds">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">ID</th>
        <th scope="col">Data di inizio</th>
        <th scope="col">Data di fine</th>
        <th scope="col">Evento</th>
        <th scope="col">Caregiver</th>
        <th scope="col">Ore imputate</th>
        <th scope="col">Stato pagamento</th>
        <th scope="col">Link di pagamento</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let round of rounds; let i = index">
        <!-- Riga visibile -->
        <tr (click)="toggleForm(i)" style="cursor: pointer;">
          <th scope="row">{{ round.id }}</th>
          <td>{{ round.startDate.split('T')[0] }}</td>
          <td>{{ round.endDate.split('T')[0] }}</td>
          <td>{{ round.eventType | eventTypeTranslate }}</td>
          <td>{{ round.caregiverId }}</td>
          <td>{{ round.hoursWorked }}</td>
          <td>{{ round.paymentStatus | roundPaymentStatus }}</td>

          @if (round.paymentLink) {
          <td (click)="onCopyClick($event, round.paymentLink)">
            <span class="me-2"><i class="bi bi-check-circle-fill text-success"></i></span>
            Copia link
          </td>
          } @else {
          <td>
            <span class="me-2"><i class="bi bi-x-circle-fill text-danger"></i></span>
            Link non presente
          </td>
          }
          <td>
            <button class="btn btn-danger text-white" (click)="deleteRound($event, round.id!)">
              <span><i class="bi bi-trash-fill"></i></span></button>
          </td>
        </tr>

        <!-- Riga del form visibile solo se selezionata -->
        <tr *ngIf="activeIndex === i">
          <td colspan="9">
            <app-request-record-form [hoursComputed]="hoursComputed" [caregiverDTO]="caregiverDTO"
              (onUpdate)="updateRecord()" (onDelete)="updateRecord()" [requestId]="round.requestId"
              [record]="round"></app-request-record-form>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<ng-template #noRounds>
  <p class="text-center fw-bold">Nessun round attivo su questa richiesta</p>
</ng-template>


<app-alert *ngIf="showDeleteConfirm" (save)="confirmDelete($event)" [data]="{ type: undefined }"
  [title]="'Conferma eliminazione'" [message]="
        'Sei sicuro di voler eliminare il record N° ' + recordID + '?'
      ">
</app-alert>
